export const CHECKOUT_URL = 'https://mma-coach-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/driCPo8hP8V6hiaA2AvzBc/Diseno_sin_titulo_(69).png'

export const packageVolumes = [
  'Volume 1 — MMA Foundations, Stance, Footwork & Distance Control',
  'Volume 2 — MMA Striking, Defense & Combination Development',
  'Volume 3 — Clinch, Cage Control & Takedown Integration',
  'Volume 4 — Ground Control, Ground-and-Pound & Submission Integration',
  'Volume 5 — Transitions, Scrambles & Full-Phase MMA Integration',
  'Volume 6 — 150 Ready-to-Coach MMA Sessions',
]

export const packageBonuses = [
  'MMA Coaching Cues & Error Correction Handbook',
  'MMA Class Planning & Session Structure Guide',
  'MMA Athlete Assessment & Progression System',
  'MMA Sparring Control & Safety Handbook',
  'MMA Training Problems & Coaching Solutions Manual',
]

export const packageExtras = [
  '100% Visual Coaching System',
  'Beginner to Advanced',
  'Immediate Digital Access',
  'PDF Format',
]

export const finalIncludedItems = [
  '6 Complete Volumes',
  '150 Ready-to-Coach MMA Sessions',
  '100% Visual Coaching System',
  'MMA Striking Systems',
  'Clinch & Cage Control',
  'Takedown Integration',
  'Ground Control',
  'Scrambles & Transitions',
  'Coach-Ready Progressions',
  '5 Professional Bonus Guides',
  'Immediate Digital Access',
  'PDF Format',
]
